import React from 'react';
import FooterBlock from './components/FooterBlock';
import styles from './Footer.module.scss';
import TextOrHtml from 'components/TextOrHtml/TextOrHtml';
import PageLink from 'components/PageLink/PageLink';

interface Props {
  settings: any;
  footerBlockFriendlyUrls: any;
  footerLinkFriendlyUrls: any;
}

const Footer = ({ settings,footerBlockFriendlyUrls,footerLinkFriendlyUrls }: Props) => {
 

  if (settings) {
    const { FooterBlocks } = settings;
    return (
      <footer className={styles.footer}>
        <div className={styles.wrapper}>
          <img
            src={process.env.PUBLIC_URL +'/images/logo/hoist_logo_white.svg'}
            width={215}
            height={55}
            alt="Logo"
          />
        </div>
        {Array.isArray(FooterBlocks) && FooterBlocks.length && (
       
          <div className={styles.blocks}>
            
            {FooterBlocks.map((block, index) => (     
                   footerBlockFriendlyUrls[block?.Heading] !==undefined &&
              <FooterBlock key={index} block={block} blockFriendlyUrls = {footerBlockFriendlyUrls} />
             
            ))}
          </div>
        )}
        <div className={styles.gdrp}>
          <TextOrHtml
            value={settings?.FooterGDPRText}
            className={styles.gdrpText}
          />
        </div>
        <div className={styles.credits}>
          <div className={styles.copyright}>
            {settings?.FooterCopyrightText}
          </div>
          <div className={styles.links}>
            {(settings?.FooterLinks || []).map((link: any, index: number) => (
        
              <PageLink
                key={index}
                url={(footerLinkFriendlyUrls && footerLinkFriendlyUrls[index]) ? footerLinkFriendlyUrls[index] : link.href }
                text={link.Text}
                className={styles.link}
              />
             
            ))}
          </div>
        </div>
      </footer>
    );
  }
  return null;
};

export default Footer;
